import { Box, Flex } from '@chakra-ui/react';
import { Logomark4C } from '@codametrix/verdigris';
import React from 'react';
import type { CodeProvenanceKind } from '../../interface/transactionCodes';
import {
  PROV_CLINICAL_BG,
  PROV_CLINICAL_ICON,
  PROV_CLINICAL_INK,
  PROV_CLINICAL_SIZE,
  PROV_LOGO_H,
  PROV_MARK_H,
  PROV_MARK_RADIUS,
  PROV_MARK_W
} from '../../styles/tokens';

export const ProvenanceIcons: React.FC<{ readonly provenance: readonly CodeProvenanceKind[] }> = ({
  provenance
}) => (
  <Flex as="span" gap="4px" data-testid="provenance-icons">
    <Box
      as="span"
      title="CodaMetrix"
      role="img"
      aria-label="CodaMetrix"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={PROV_MARK_W}
      h={PROV_MARK_H}
      borderRadius={PROV_MARK_RADIUS}
      sx={{ svg: { width: PROV_MARK_W, height: PROV_LOGO_H } }}
    >
      <Logomark4C iconWidth="19" />
    </Box>
    {provenance.includes('clinical') && (
      <Box
        as="span"
        title="Provider Charge"
        role="img"
        aria-label="Provider Charge"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        w={PROV_CLINICAL_SIZE}
        h={PROV_CLINICAL_SIZE}
        bg={PROV_CLINICAL_BG}
        color={PROV_CLINICAL_INK}
        borderRadius={PROV_MARK_RADIUS}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width={PROV_CLINICAL_ICON}
          height={PROV_CLINICAL_ICON}
          aria-hidden="true"
        >
          <path d="M4.5 2.5V8a4.5 4.5 0 0 0 9 0V2.5" />
          <path d="M4.5 2.5h-1M13.5 2.5h1" />
          <path d="M9 12.5v2.5a5 5 0 0 0 10 0v-1.5" />
          <circle cx="19" cy="11" r="2" />
        </svg>
      </Box>
    )}
  </Flex>
);
